import { render } from "./contact.vue?vue&type=template&id=608c094f&ts=true"
import script from "./contact.vue?vue&type=script&lang=ts"
export * from "./contact.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/nolan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__